<script lang="ts">
  import { Col, Row } from "sveltestrap";
  import { Follower, Following, TotalPost } from "../../../../utils/Constant/Constant";
  import Link from "svelte-link";
  export let userData
</script>
<div class="text-center profile-details">
  <Link href="/users/usersprofile">
    <h4>{userData.name}</h4>
  </Link>
  <h6>{userData.status}</h6>
</div>
<Row class="card-footer">
  <Col sm="4" xs="4" >
    <h6>{Follower}</h6>
    <h3 class="counter">{userData.follwers}</h3>
  </Col>
  <Col sm="4" xs="4">
    <h6>{Following}</h6>
    <h3><span class="counter">{userData.followings}</span>K</h3>
  </Col>
  <Col sm="4" xs="4">
    <h6>{TotalPost}</h6>
    <h3><span class="counter">{userData.post}</span>M</h3>
  </Col>
</Row>